<template>
    <section class="section-padding" id="register">
        <div class="container-fluid container-lg">
            <div class="row justify-content-center align-items-center">
                <div class="col-12 text-center section-header">
                    <h2 class="mb-2">Register</h2>
                    <p>Take a bold step in your journey of becoming a professional software developer</p>
                </div>
            </div>
            <div class="row justify-content-center align-items-center g-lg-4 mt-3 mt-lg-4 px-md-5 px-lg-0">
                <div class="col-lg-6 text-center">
                    <img class="img-fluid" src="../assets/registerimage.png" alt="Register Image Left">
                </div>
                <div class="col-lg-6">
                    <div class="px-3 px-lg-0">
                        <div class="row">
                            <div class="col"> 
                                <div class="form-group mb-3">
                                    <input class="form-control" v-model="firstname" type="email" placeholder="Firstname" required>
                                </div>
                            </div>
                            <div class="col"> 
                                <div class="form-group mb-3">
                                    <input class="form-control" v-model="lastname" type="email" placeholder="Lastname" required>
                                </div>
                            </div>
                        </div>

                        <div class="form-group mb-3">
                            <input class="form-control" v-model="email" type="email" placeholder="Your Email" required>
                        </div>

                        <div class="form-group mb-3">
                            <input class="form-control" v-model="metadata.custom_fields[0].value" type="text" placeholder="Your Phone number">
                        </div>
                        <paystack
                            :amount="amount"
                            :email="email"
                            :firstname="firstname"
                            :lastname="lastname"
                            :paystackkey="paystackkey"
                            :reference="reference"
                            :callback="callback"
                            :close="close"
                            :embed="false"
                            :metadata="metadata"
                            class="mt-1 call-to-action"
                        >
                        <i class="fas fa-money-bill-alt"></i>
                        Enroll Now
                        </paystack>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import paystack from 'vue-paystack';

export default {
    components: {
        paystack
    },
    data(){
        return{
            paystackkey: "pk_live_7e8819b1f2c12617e3211854c4a8e9603750c1df", //paystack public key
          email: "", // Customer email
          firstname: "", //Firstname
          lastname: "", // Lastname
          metadata: {
            "custom_fields": [
                {
                  "display_name":"Student Phone Number",
                  "variable_name":"student_phone_number",
                  "value": ""
                },
            ]
          },
          amount: 30000000 // in kobo
        }
    },
    computed: {
      reference(){
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
 
        for( let i=0; i < 10; i++ )
          text += possible.charAt(Math.floor(Math.random() * possible.length));
 
        return text;
      }
    },
    methods: {
      callback: function(response){
        console.log(response)
      },
      close: function(){
          console.log("Payment closed")
      }
    }
}
</script>

<style>
#register h2 {
        font-size: 1.3rem;
        color: var(--dacode-primary-color);
}

#register .call-to-action {
    padding: .8rem 2rem;
}
</style>
